import React from 'react';
import '../../styles/sections.css';
import '../../styles/swipe.css';

import awsLambda from '../../assets/SwipeImages/AWSLambda.png';
import expo from '../../assets/SwipeImages/Expo.png';
import go from '../../assets/SwipeImages/Go.png';
import neon from '../../assets/SwipeImages/Neon.png';
import pinata from '../../assets/SwipeImages/Pinata.png';
import postgresql from '../../assets/SwipeImages/PostgreSQL.svg.png';
import reactNative from '../../assets/SwipeImages/ReactNative.png';

const TechnologyShowcase = () => {
  const technologyImages = [
    { img: reactNative, name: 'React Native' },
    { img: expo, name: 'Expo' },
    { img: go, name: 'Go' },
    { img: awsLambda, name: 'AWS Lambda' },
    { img: postgresql, name: 'PostgreSQL' },
    { img: neon, name: 'Neon' },
    { img: pinata, name: 'IPFS Pinata' }
  ];

  // Duplicate images for seamless loop
  const duplicatedImages = [...technologyImages, ...technologyImages];

  return (
    <section className="appshowcase-section technology-showcase-section">
      <div className="technology-scroll-container">
        <div className="technology-scroll-track">
          {duplicatedImages.map((tech, idx) => (
            <div key={idx} className="technology-logo-item">
              <img src={tech.img} alt={tech.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnologyShowcase;

